import { render, staticRenderFns } from "./planMock.vue?vue&type=template&id=baf5c05c&scoped=true&"
import script from "./planMock.vue?vue&type=script&lang=js&"
export * from "./planMock.vue?vue&type=script&lang=js&"
import style0 from "./planMock.vue?vue&type=style&index=0&id=baf5c05c&scoped=true&lang=less&"
import style1 from "./planMock.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf5c05c",
  null
  
)

export default component.exports